import { Box, Checkbox, TableCell, TableRow, Typography } from '@mui/material';
import { StatusChip } from './StatusChip';
import {
  DocumentTypeCell,
  DateOfServiceCell,
  DaysRemainingCell,
  ActionButtons,
} from './DocumentTableCells';

type DocumentTableRowProps = {
  document: any;
  onPreview: (doc: any) => void;
  selected: boolean;
  onSelect: (document: any, checked: boolean) => void;
  isSignedExternally?: boolean;
};

export const DocumentTableRow = ({
  document,
  onPreview,
  selected,
  onSelect,
  isSignedExternally,
}: DocumentTableRowProps) => {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSelect(document, event.target.checked);
  };

  return (
    <TableRow
      hover
      key={document?.uuid}
    >
      <TableCell>
        <Typography variant="subtitle2">{document?.patientName}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="subtitle2">{document?.facilityName}</Typography>
      </TableCell>
      <TableCell>
        <DocumentTypeCell document={document} />
      </TableCell>
      <TableCell>
        <DateOfServiceCell dateOfService={document?.dateOfService} />
      </TableCell>
      <TableCell align="left">
        <DaysRemainingCell dateOfService={document?.dateOfService} />
      </TableCell>
      <TableCell>
        <Box sx={{ display: 'flex', ml: '-20px' }}>
          <StatusChip
            document={document}
            isSignedExternally={isSignedExternally}
          />
        </Box>
      </TableCell>
      <TableCell align="left">
        <ActionButtons onPreview={() => onPreview(document)} />
      </TableCell>
      <TableCell padding="checkbox">
        <Checkbox
          color="primary"
          checked={selected}
          onChange={handleCheckboxChange}
        />
      </TableCell>
    </TableRow>
  );
};
